require('./bootstrap');

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})
